export const  mobileZh = {
  MobileInstructions: '手机监考说明',
  mobileDesc: '本场考试已开启手机监考，请打开手机微信或QQ扫码连接手机摄像头。',
  mobileDesc1: '',
  Cautions: '注意事项',
  mobileCheck: {
    Battery: '检查电量',
    Internet: '检查网络',
    RunningApps: '关闭后台应用'
  },
  tipsConcat: {
    one: '1、扫码后请【允许】手机摄像头授权，并按指引完成手机监考流程',
    two: '2、若手机监考断连，可通过电脑端的【求助】-【监考二维码】进行重连'
  },
  connected: '已连接'
}
export const  mobileEn = {
  MobileInstructions: 'Mobile Proctoring Instructions',
  mobileDesc: 'Mobile proctoring has been enabled for this exam.',
  mobileDesc1: 'Please open WeChat or QQ to scan the QR code to connect to the camera of your mobile phone.',
  Cautions: 'Cautions',
  mobileCheck: {
    Battery: 'Battery Check',
    Internet: 'Internet Check',
    RunningApps: 'Close All Running Apps'
  },
  tipsConcat: {
    one: '1. After scanning the code, please [Allow] the authorization of mobile phone camera, and go through the invigilation process with instructions.',
    two: '2. If your phone disconnected, you can rescan the code from [Help] - [proctoring QR code] on the computer.'
  },
  connected: 'connected'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/proctor/mobile.js